var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"small-spinner",style:({
    width: _vm.sideSize,
    height: _vm.sideSize
  }),attrs:{"viewBox":_vm.viewBoxParam,"version":"1.1","xmlns":"http://www.w3.org/2000/svg"}},[_c('circle',{staticClass:"small-spinner-circle",attrs:{"cx":_vm.centerOffset,"cy":_vm.centerOffset,"r":_vm.radius,"stroke-width":_vm.strokeWidth,"stroke-dasharray":_vm.dashArray,"fill":"none","stroke-miterlimit":"10"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }